<template>
  <el-drawer :title="drawerTitle" :visible.sync="drawer" size="50%" :before-close="handleClose">
    <div class="m-tabs-content">
      <company-info :company-name="companyName" />
    </div>
  </el-drawer>
</template>

<script>
import CompanyInfo from "./CompanyInfo.vue"
export default {
  name: 'RisksDrawer',
  components: {
    CompanyInfo
  },
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    drawerTitle: {
      type: String,
      default: ''
    },
    companyName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  methods: {
    handleClose () {
      this.$emit('handleClose', false)
    }
  }
}
</script>
<style lang="stylus" scoped>
.m-tabs-content {
  padding: 0 0.2rem 0 0.4rem;
}
* >>> .el-drawer__header {
  color: #409eff;
  font-size: medium;
}
</style>



// WEBPACK FOOTER //
// src/pages/company_risks/common/CompanyInfoDrawer.vue